import { PaginatedResponse, User } from '@arpeggi/shared'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useMutation,
  useQuery,
  UseQueryOptions
} from 'react-query'
import { queryClient } from '../../features/react-query-provider/ReactQueryClientProvider'
import {
  CreateUserDto,
  GetUsersParams,
  Parts,
  UpdateUserDto,
  useUsersAPI
} from '../api/v2/UsersAPI'
import { getNextPage, getPreviousPage } from './common'

export const useUsers = (
  params?: GetUsersParams,
  options?: UseInfiniteQueryOptions<PaginatedResponse<User>>
) => {
  const { getUsers } = useUsersAPI()

  return useInfiniteQuery(
    ['users', params],
    ({ pageParam = params?.page || 1 }) => getUsers({ ...params, page: pageParam }),
    {
      getPreviousPageParam: (firstPage) => getPreviousPage(firstPage),
      getNextPageParam: (lastPage) => getNextPage(lastPage),
      ...options
    }
  )
}

export const useUser = ({
  walletAddressOrId,
  parts,
  options
}: {
  walletAddressOrId: string | number
  parts?: Parts
  options?: UseQueryOptions<User>
}) => {
  const { getOneUser } = useUsersAPI()

  return useQuery(
    ['user', walletAddressOrId, parts],
    () => getOneUser(walletAddressOrId, { parts }),
    options
  )
}

export const useUpdateUser = (walletAddress: string) => {
  const { updateUser } = useUsersAPI()

  return useMutation((dto: UpdateUserDto) => updateUser(dto), {
    onSuccess: () => {
      queryClient.invalidateQueries(['user', walletAddress])
    }
  })
}

export const useCreateUser = () => {
  const { createUser } = useUsersAPI()

  return useMutation((dto: CreateUserDto) => createUser(dto))
}

export const useUpdateUserTwitterHandle = (walletAddress: string) => {
  const { updateUserTwitterHandle } = useUsersAPI()

  return useMutation((tweetLink: string) => updateUserTwitterHandle(tweetLink), {
    onSuccess: () => {
      queryClient.invalidateQueries(['user', walletAddress])
    }
  })
}
